import styled from '@emotion/styled'
import Head from 'next/head'
import PropTypes from 'prop-types'

import { StickyWrapper } from '@hmn/rtl-web-core/components/StickyWrapper'

import { ConditionalWrapper } from '../../../ConditionalWrapper'
import { Graphic, graphicVariants } from '../../../Decoration/components'
import PrevNextButton from '../PrevNextButton/PrevNextButton.component'
import styles from './PrevNext.style'

const PrevNextStyled = styled.div(props => ({ ...styles(props) }))

function PrevNext({
    className,
    previousButtonTitle,
    previousArticleTitle,
    previousHref,
    previousHrefAs,
    previousOnClick,
    nextButtonTitle,
    nextArticleTitle,
    nextHref,
    nextHrefAs,
    nextOnClick,
    page,
    total,
    titleTagComponent,
    sticky,
    variant,
    ...rest
}) {
    if (!(nextHref || nextOnClick) && !(previousHref || previousOnClick)) {
        return null
    }
    return (
        <>
            <PrevNextStyled className={className} variant={variant} {...rest}>
                <ConditionalWrapper condition={sticky} Wrapper={StickyWrapper} className="prevNext_wrapper">
                    <div className="prevNext">
                        <Graphic key="prev_next_graphic" className="prevNext_graphic" variant={graphicVariants.THETA} />
                        <div className="prevNext_button_wrapper">
                            <div className="prevNext_button" key="prev_next_prev">
                                <PrevNextButton
                                    buttonTitle={previousButtonTitle}
                                    href={previousHref}
                                    hrefAs={previousHrefAs}
                                    onClick={previousOnClick}
                                    title={previousArticleTitle}
                                    titleTagComponent={titleTagComponent}
                                    variant={variant}
                                />
                            </div>
                            <div key="prev_next_pager" className="prevNext_count">
                                {page && total && variant === 'alpha' && `${page}/${total}`}
                            </div>
                            <div className="prevNext_button" key="prev_next_next">
                                <PrevNextButton
                                    buttonTitle={nextButtonTitle}
                                    href={nextHref}
                                    hrefAs={nextHrefAs}
                                    onClick={nextOnClick}
                                    title={nextArticleTitle}
                                    titleTagComponent={titleTagComponent}
                                    variant={variant}
                                    reverseAligned
                                />
                            </div>
                        </div>
                    </div>
                </ConditionalWrapper>
            </PrevNextStyled>
            <Head>
                {previousHref && <link rel="prev" href={`${process.env.NEXT_PUBLIC_APP_ROOT_ZENA + previousHref}`} />}
                {nextHref && <link rel="next" href={`${process.env.NEXT_PUBLIC_APP_ROOT_ZENA + nextHref}`} />}
            </Head>
        </>
    )
}

const prevNextVariants = Object.freeze({
    ALPHA: 'alpha', // prev-next article
    BETA: 'beta' // hunk of the day article
})

PrevNext.propTypes = {
    titleTagComponent: PropTypes.elementType,
    className: PropTypes.string,
    previousButtonTitle: PropTypes.string,
    previousArticleTitle: PropTypes.string,
    previousHref: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
    previousHrefAs: PropTypes.string,
    previousOnClick: PropTypes.func,
    nextButtonTitle: PropTypes.string,
    nextArticleTitle: PropTypes.string,
    nextHref: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
    nextHrefAs: PropTypes.string,
    nextOnClick: PropTypes.func,
    page: PropTypes.number,
    total: PropTypes.number,
    sticky: PropTypes.bool,
    variant: PropTypes.oneOf([...Object.values(prevNextVariants)])
}

PrevNext.defaultProps = {
    titleTagComponent: 'h3',
    className: undefined,
    previousButtonTitle: 'PRETHODNA',
    previousArticleTitle: undefined,
    previousHref: undefined,
    previousHrefAs: undefined,
    previousOnClick: undefined,
    nextButtonTitle: 'SLJEDEĆA',
    nextArticleTitle: undefined,
    nextHref: undefined,
    nextHrefAs: undefined,
    nextOnClick: undefined,
    page: undefined,
    total: undefined,
    sticky: false,
    variant: prevNextVariants.ALPHA
}
export { prevNextVariants }
export default PrevNext
